<template>
  <transition name="snack" appear>
    <div
      v-if="state.visible"
      class="fixed right-6 bottom-6 z-50 w-[min(95%,420px)] pointer-events-auto"
    >
      <div
        :class="[
          'rounded-lg shadow-lg px-4 py-3 flex items-center gap-3',
          state.variant === 'success'
            ? 'bg-green-50 border border-green-200 text-green-900'
            : '',
          state.variant === 'error'
            ? 'bg-red-50 border border-red-200 text-red-900'
            : '',
          state.variant === 'info'
            ? 'bg-white border border-gray-200 text-gray-900'
            : '',
        ]"
        style="transform-origin: right bottom"
      >
        <div class="flex-shrink-0">
          <svg
            v-if="state.variant === 'success'"
            class="w-5 h-5 text-green-600"
            viewBox="0 0 20 20"
            fill="currentColor"
            aria-hidden="true"
          >
            <path
              fill-rule="evenodd"
              d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414L9 13.414l4.707-4.707z"
              clip-rule="evenodd"
            />
          </svg>
          <svg
            v-else-if="state.variant === 'error'"
            class="w-5 h-5 text-red-600"
            viewBox="0 0 20 20"
            fill="currentColor"
            aria-hidden="true"
          >
            <path
              fill-rule="evenodd"
              d="M10 18a8 8 0 100-16 8 8 0 000 16zm-1-9V6a1 1 0 112 0v3a1 1 0 11-2 0zm1 6a1.5 1.5 0 110-3 1.5 1.5 0 010 3z"
              clip-rule="evenodd"
            />
          </svg>
          <svg
            v-else
            class="w-5 h-5 text-gray-600"
            viewBox="0 0 20 20"
            fill="currentColor"
            aria-hidden="true"
          >
            <path
              d="M2 10a8 8 0 1116 0A8 8 0 012 10zm8-4a1 1 0 100 2 1 1 0 000-2z"
            />
          </svg>
        </div>

        <div class="flex-1 text-sm leading-tight">
          <div class="font-medium">{{ state.message }}</div>
          <div v-if="state.detail" class="text-xs text-gray-500 mt-1">
            {{ state.detail }}
          </div>
        </div>

        <button
          v-if="state.action"
          class="ml-3 px-3 py-1.5 text-xs font-medium rounded hover:bg-black/5 transition-colors"
          :class="[
            state.variant === 'success' ? 'text-green-700' : '',
            state.variant === 'error' ? 'text-red-700' : '',
            state.variant === 'info' ? 'text-gray-700' : '',
          ]"
          @click="
            () => {
              state.action?.handler();
              hide();
            }
          "
        >
          {{ state.action.label }}
        </button>

        <button
          class="ml-3 text-xs text-gray-500 hover:text-gray-700"
          @click="hide()"
          aria-label="Fermer"
        >
          <Icon name="heroicons:x-mark" class="w-4 h-4" />
        </button>
      </div>
    </div>
  </transition>
</template>

<script setup lang="ts">
import Icon from "~/components/Icon.vue";
import { useSnackbar } from "~/composables/ui/useSnackbar";
const { state, hide } = useSnackbar();
</script>

<style scoped>
/* Smooth fade-in-up with translateY */
.snack-enter-active,
.snack-leave-active {
  transition: opacity 200ms ease, transform 200ms ease;
}
.snack-enter-from {
  opacity: 0;
  transform: translateY(8px);
}
.snack-enter-to {
  opacity: 1;
  transform: translateY(0);
}
.snack-leave-from {
  opacity: 1;
  transform: translateY(0);
}
.snack-leave-to {
  opacity: 0;
  transform: translateY(8px);
}
</style>
